import styled from "styled-components";
import {
	COLOR_TEXT_PRIMARY_B2U,
	FONT_SIZE_16,
	FONT_SIZE_18,
	FONT_WT_HEAVY,
	TABLET_BP,
} from "@website-builder/utilities-index";

export const ItemWrapper = styled.section`
	display: flex;
	align-items: center;

	aside {
		margin-right: 30px;
		img {
			width: 180px;
		}
	}

	h2 {
		font-size: ${FONT_SIZE_18};
	}

	p,
	h1,
	h2 {
		margin: 0;
	}

	h2 {
		margin-bottom: 5px;
	}

	p {
		margin-bottom: 10px;
		&.date {
			font-size: 14px;
		}
		&.description {
			word-wrap: break-word;
			height: calc(24px * 3);
			word-break: normal;
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
			overflow: hidden;
		}
	}

	a.read-more {
		font-size: ${FONT_SIZE_16};
		font-weight: ${FONT_WT_HEAVY};
		color: ${COLOR_TEXT_PRIMARY_B2U};
	}

	a.header-as-link {
		font-size: ${FONT_SIZE_18};
		font-weight: ${FONT_WT_HEAVY};
		color: ${COLOR_TEXT_PRIMARY_B2U};
	}

	@media only screen and (max-width: ${TABLET_BP - 1}px) {
		flex-direction: column;
		align-items: flex-start;
		aside {
			margin-bottom: 20px;
		}
		p {
			&.description {
				height: calc(24px * 4);
				-webkit-line-clamp: 4;
			}
		}
	}
`;
